import React from 'react';
import PageTemplate from '../../../components/common/template/PageTemplate';
import ClearfaceView from './ClearfaceView';

const Clearface = () => {
  return (
    <PageTemplate noMargin>
      <ClearfaceView />
    </PageTemplate>
  );
};

export default React.memo(Clearface);
